import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import StartScreen from './StartScreen'
import EventProGame from './EventProGame'
import LeaderboardPage from './LeaderboardPage'
import HowToPlayPage from './HowToPlayPage'
import LegacyGame from './legacy/EventProGame'
import LegacyLeaderboardPage from './legacy/LeaderboardPage'
import LegacyHowToPlayPage from './legacy/HowToPlayPage'
import LegacyStartScreen from './legacy/StartScreen'
import useGameMode from './useGameMode'
import { bgMuted } from './styles'

const installHubAuthFetch = () => {
  if (typeof window === 'undefined' || window.__hubAuthFetchInstalled) return
  const originalFetch = window.fetch.bind(window)
  window.fetch = (input, init = {}) => {
    const token = new URLSearchParams(window.location.search).get('hub_token') || localStorage.getItem('hubToken') || ''
    if (token) localStorage.setItem('hubToken', token)
    const headers = new Headers(init.headers || {})
    if (token) headers.set('X-Hub-Token', token)
    return originalFetch(input, { ...init, headers })
  }
  window.__hubAuthFetchInstalled = true
}

installHubAuthFetch()

const LOGIN_URL = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? 'http://localhost:3000' : 'https://games.precisionpros.com'
const PLAYABLE_ROUTES = new Set(['/'])

const shouldRedirectToUnifiedLogin = () => {
  if (typeof window === 'undefined') return false

  const { hostname, pathname, search } = window.location
  const params = new URLSearchParams(search)
  const hasHubToken = params.get('hub_token') || localStorage.getItem('hubToken')
  const isLocalDev = hostname === 'localhost' || hostname === '127.0.0.1'

  return !isLocalDev && !hasHubToken && PLAYABLE_ROUTES.has(pathname)
}

function App() {
  const { mode, error } = useGameMode()
  const Game = mode?.mode === 'timed' ? EventProGame : LegacyGame
  const Login = mode?.mode === 'timed' ? StartScreen : LegacyStartScreen
  const Board = mode?.mode === 'timed' ? LeaderboardPage : LegacyLeaderboardPage
  const Help = mode?.mode === 'timed' ? HowToPlayPage : LegacyHowToPlayPage
  const [playerName, setPlayerName] = useState(() => {
    // Check query parameter first (from main login page), then localStorage
    const params = new URLSearchParams(window.location.search)
    const queryParam = params.get('player_name')
    if (queryParam) {
      localStorage.setItem('playerName', queryParam)
      return queryParam
    }
    return localStorage.getItem('playerName') || null
  })

  useEffect(() => {
    if (shouldRedirectToUnifiedLogin()) {
      window.location.replace(LOGIN_URL)
    }
  }, [])

  useEffect(() => {
    if (playerName) {
      localStorage.setItem('playerName', playerName)
    } else {
      localStorage.removeItem('playerName')
    }
  }, [playerName])

  if (!mode) return <p role={error ? 'alert' : 'status'} style={{ padding: 40, textAlign: 'center' }}>{error || 'Loading today’s game…'}</p>

  return (
    <BrowserRouter key={`${mode.mode}:${mode.date}`}>
      <div style={{ minHeight: '100vh', backgroundColor: bgMuted }}>
        <Routes>
          <Route
            path="/"
            element={
              playerName ? (
                <Game playerName={playerName} onLogout={() => setPlayerName(null)} />
              ) : (
                <Login onNameSet={setPlayerName} />
              )
            }
          />
          <Route path="/leaderboard" element={<Board timedStartDate={mode.timed_start_date} playerName={playerName} />} />
          <Route path="/how-to-play" element={<Help />} />
        </Routes>
      </div>
    </BrowserRouter>
  )
}

export default App
